// @flow

import React, { Component } from 'react';
import Relay from 'react-relay';
import { observer } from 'mobx-react';

import Contacts from '../Components/Contacts';
import ListContainer from './ListContainer';
import ContactInfo from '../Components/ContactInfo';
import ResourcesEditList from '../Components/ResourcesEditList';
import ProtectedContacts from '../Components/Protected/ProtectedContacts';

import getLanguage from '../libs/Languages';
import breakpoints from '../../css/breakpoints';
import { uiStateStoreInstance } from '../Stores/UIStateStore';

@observer
class ContactsContainer extends Component {
  constructor(props) {
    super(props);
    const { viewer } = props;
    const isAdmin = viewer.me.permissions.find(permission => permission === 'CLASSIFY_RESOURCE');
    uiStateStoreInstance.setIsAdmin(isAdmin);
    uiStateStoreInstance.activeView = 'contact';
  }
  state: {
    loading: boolean,
    showContactInfoMobile: boolean,
    defaultTab: string,
  };
  state = {
    loading: false,
    showContactInfoMobile: false,
    defaultTab: this.props.tab,
  };

  componentWillReceiveProps(nextProps: Object) {
    if (this.state.defaultTab !== nextProps.tab) {
      this.setState({
        defaultTab: nextProps.tab,
      });
    }
  }

  props: {
    relay: Object,
    viewer: Object,
    resourcesEditList: Object,
    selectedContactEmail: string,
    location: Object,
    params: Object,
    tab: string,
  };

  _handleContactSelection(type) {
    this.setState({ loading: true });
    if (window.innerWidth <= breakpoints.MOBILE_CONTACT_INFO) {
      this.setState({
        showContactInfoMobile: true,
      });
    }
    const readyStateCb = (readyState) => {
      if (readyState.done || readyState.aborted) {
        this.setState({
          loading: false,
        });
      } else if (readyState.error) {
        this.setState({ loading: false });
      }
    };
    type === 'contact' ?
    this.props.relay.setVariables({
      showMeetingRoom: uiStateStoreInstance.showMeetingRoom,
      showOtherResource: uiStateStoreInstance.showOtherResource,
      selectedContactEmail: uiStateStoreInstance.selectedContactEmail,
      emails: uiStateStoreInstance.emails.slice(),
    }, readyState => readyStateCb(readyState)) :
    this.props.relay.setVariables({
      showMeetingRoom: uiStateStoreInstance.showMeetingRoom,
      showOtherResource: uiStateStoreInstance.showOtherResource,
      emails: uiStateStoreInstance.emails.slice(),
    }, readyState => readyStateCb(readyState));
  }

  _toggleContactInfoMobile() {
    this.setState({
      showContactInfoMobile: false,
    });
  }

  _clearList = () => {
    uiStateStoreInstance.setEmails([]);
    this.props.relay.setVariables({
      emails: [null],
      showMeetingRoom: false,
      showOtherResource: false,
    }, (readyState) => {
      if (readyState.done || readyState.aborted) {
        uiStateStoreInstance.ids = [];
        uiStateStoreInstance.setShowMeetingRoom(false);
        uiStateStoreInstance.setShowOtherResource(false);
      }
    });
  }

  render() {
    const { defaultTab } = this.state;
    const { me } = this.props.viewer;
    const mode = uiStateStoreInstance.adminMode ? 'multi' : 'single';
    let selectedContactEmail;
    this.props.relay.variables.emails[0] !== null ?
      selectedContactEmail = this.props.relay.variables.emails[0] :
      selectedContactEmail = this.props.relay.variables.selectedContactEmail;

    return (
      <div>
        <ListContainer
          mode={mode}
          defaultTab={defaultTab}
          messages={getLanguage()}
          viewer={this.props.viewer}
          selectedContactEmail={selectedContactEmail}
          contactEmail={me.email}
          selectedContact={this.props.relay.variables.emails} // In case of admin mode
          languagedata={getLanguage()}
          toggleItem={(email, type) => {
            this._handleContactSelection(email, type);
          }}
        />
        <Contacts
          viewer={this.props.viewer}
          resourcesEditList={this.props.viewer}
          selectedContactEmail={this.props.relay.variables.selectedContactEmail}
          showContact={this.props.relay.variables.showContact}
          showMeetingRoom={this.props.relay.variables.showMeetingRoom}
          showOtherResource={this.props.relay.variables.showOtherResource}
          emails={this.props.relay.variables.emails}
          languagedata={getLanguage()}
          loading={this.state.loading}
          showContactInfoMobile={this.state.showContactInfoMobile}
          toggleContactInfoMobile={() => { this._toggleContactInfoMobile(); }}
          clearList={this._clearList}
          protectedComponent={ProtectedContacts}
          me={me}
        />
      </div>
    );
  }

}


export default Relay.createContainer(ContactsContainer, {
  initialVariables: {
    selectedContactEmail: null,
    showMeetingRoom: false,
    showOtherResource: false,
    emails: [null],
  },
  fragments: {
    viewer: (vars) => Relay.QL`
      fragment on Viewer {
        me {
          email
          displayName
          permissions
        }
        ${ContactInfo.getFragment('viewer', vars)},
        ${ListContainer.getFragment('viewer', vars)},
        ${ResourcesEditList.getFragment('resourcesEditList', vars)},
      }
    `,
  },
});



// WEBPACK FOOTER //
// ./src/js/Containers/ContactsContainer.js